import { useStore } from 'hooks/useStore';
import { ITalentAnalysisTool } from 'domain/store/talentAnalysisTool/TalentAnalysisToolModel';

export function useTalentAnalysis(): ITalentAnalysisTool {
  const { talentAnalysis } = useStore();

  return talentAnalysis;
}
